import { render, staticRenderFns } from "./noticeLook.vue?vue&type=template&id=09f2004d&scoped=true"
import script from "./noticeLook.vue?vue&type=script&lang=js"
export * from "./noticeLook.vue?vue&type=script&lang=js"
import style0 from "./noticeLook.vue?vue&type=style&index=0&id=09f2004d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f2004d",
  null
  
)

export default component.exports